import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { usePosition } from "../../hooks/usePosition";
import PositionModule from "../../components/modules/Position/PositionModule";

const PositionPage = ({ user, isHideSideMenu }) => {
  const posMethods = usePosition();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Position"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Position</h3>
            </div>

            <PositionModule
              user={user}
              {...posMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={posMethods.showMessage}
        message={posMethods.message}
        isSuccess={posMethods.isSuccess}
      />

      <LoadingSpinner loading={posMethods.loading} />
    </>
  );
};

export default PositionPage;